<template>
<div class="home blog-index-gbwhatpro page-template-default page separate-containers nav-below-header">
  <HeadNav selectedLanguage="en" page="blogs" />

  <GuideBreadcrumb :items="breadcrumbItems" />

  <div id="page" class="site grid-container container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main">

          <section class="blog-index-hero blog-index-hero--split" aria-labelledby="blog-index-title">
            <div class="blog-index-hero__inner blog-index-hero__inner--split">
              <div class="blog-index-hero__copy">
                <p class="blog-index-hero__kicker">{{ hero.kicker }}</p>
                <h1 id="blog-index-title">{{ hero.h1 }}</h1>
                <p class="blog-index-hero__lead">{{ hero.lead }}</p>
              </div>
              <figure class="blog-index-hero__visual">
                <img
                  :src="heroImage"
                  alt=""
                  width="480"
                  height="320"
                  loading="eager"
                  decoding="async"
                >
              </figure>
            </div>
          </section>

          <div class="section-content section-content--band">
            <h2 class="h">{{ start.h2 }}</h2>
            <p v-for="(p, i) in start.paragraphs" :key="'sp' + i" v-html="p" />
            <ul class="blog-index-start__links">
              <li v-for="(link, li) in start.links" :key="li">
                <a class="blog-index-start__link" :href="link.href">{{ link.label }}</a>
              </li>
            </ul>
          </div>

          <div v-if="page === 1 && featuredPosts.length" class="section-content">
            <h2 class="h">{{ sections.featuredH2 }}</h2>
            <p class="blog-index-section-lead">{{ sections.featuredLead }}</p>
            <div class="gbpro-featured-grid">
              <a
                v-for="post in featuredPosts"
                :key="post.slug"
                class="gbpro-featured-card"
                :href="`/${post.slug}/`"
              >
                <BlogCardCover
                  :image="post.coverSrc"
                  :alt="post.title"
                  :theme="post.coverTheme"
                  :label="post.coverLabel"
                />
                <div class="gbpro-featured-card__body">
                  <span v-if="post.categoryLabel" class="gbpro-article-list__tag">{{ post.categoryLabel }}</span>
                  <h3>{{ post.title }}</h3>
                  <p>{{ post.description }}</p>
                </div>
              </a>
            </div>
          </div>

          <div class="section-content">
            <h2 class="h">{{ sections.latestH2 }}</h2>
            <BlogPostList :posts="listPostsForPage" />
            <BlogPagination :page="page" :total-pages="totalPages" base-path="/blog/" />
            <p class="blog-index-disclaimer">{{ sections.disclaimer }}</p>
          </div>

        </main>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import '@/css/base.scss'
import '@/css/index.scss'
import '@/css/gb-home-layout.scss'
import '@/css/guide-pages.scss'
import '@/css/blog-gbwhatpro-index.scss'
import HeadNav from '@/components/HeadNav.vue'
import GuideBreadcrumb from '@/components/GuideBreadcrumb.vue'
import BlogPagination from '@/components/blog/BlogPagination.vue'
import BlogPostList from '@/components/blog/BlogPostList.vue'
import BlogCardCover from '@/components/blog/BlogCardCover.vue'
import { getPostCoverSrc, getBlogHeroImage } from '@/constants/blogCovers'
import {
	blogHubHero,
	blogHubStart,
	blogHubSections,
} from '@/data/blogHubPage'
import { getSiteBlogPosts, getLatestPosts, paginatePosts, formatBlogDate } from '@/utils/blog'

export default {
	name: 'BlogIndex',
	components: { HeadNav, GuideBreadcrumb, BlogPagination, BlogPostList, BlogCardCover },
	data() {
		return {
			hero: blogHubHero,
			start: blogHubStart,
			sections: blogHubSections,
			heroImage: getBlogHeroImage(),
		}
	},
	computed: {
		breadcrumbItems() {
			return [
				{ label: 'Home', href: '/' },
				{ label: 'Blog' },
			]
		},
		page() {
			const p = Number(this.$route.query.page)
			return Number.isFinite(p) && p > 0 ? p : 1
		},
		paginated() {
			return paginatePosts(getSiteBlogPosts(), this.page)
		},
		featuredPosts() {
			return getLatestPosts(3).map((post) => this.enrichPost(post))
		},
		pagePosts() {
			return this.paginated.items.map((post) => this.enrichPost(post))
		},
		listPostsForPage() {
			if (this.page !== 1) return this.pagePosts
			const skip = new Set(this.featuredPosts.map((p) => p.slug))
			return this.pagePosts.filter((p) => !skip.has(p.slug))
		},
		totalPages() {
			return this.paginated.totalPages
		},
	},
	methods: {
		formatDate: formatBlogDate,
		enrichPost(post) {
			return {
				...post,
				coverSrc: getPostCoverSrc(post.slug),
				coverTheme: post.coverTheme || 'safe',
				coverLabel: post.coverLabel || post.title,
			}
		},
	},
}
</script>
